import React, { useState, useEffect } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import { Link } from "react-router-dom";
import helperNumber from "../../../helpers/numbers";
import mobileHelper from "../../../helpers/mobile";
import TitleBar from "../../partials/content/TitleBar";
import ListUserCustomerCoWorker from "./ListUserCustomerCoWorker";
import ButtonDisable from "../../partials/other/ButtonDisable";

export default function AllUserCustomerCoWorker() {
  const generateTable = () => {
    return (
      <>
        <div className="pb-2 ">
          <Link className="btn btn-success  " to="/user/add-customer-coworker">
            <i className="fa fa-plus ml-1"></i>
            اضافه کردن کاربر
          </Link>
        </div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-all-users m-0 ">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره کاربر</td>
                <td>نام</td>
                <td>نام خانوادگی</td>
                <td>ایمیل</td>
                <td>شماره موبایل</td>
                <td>موجودی</td>
                <td>تاریخ ثبت نام</td>
                <td>تاریخ آخرین ورود کاربر</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>{generateRowTable()}</tbody>
          </table>
        </div>
      </>
    );
  };

  const generateRowTable = () => {
    return ListUserCustomerCoWorker.map((user, index) => {
      return (
        <tr>
          <td>{helperNumber.toPersianNum(index + 1)}</td>
          <td>{helperNumber.toPersianNum(user.id)}</td>
          <td>{user.first_name}</td>
          <td>{user.last_name}</td>
          <td>{user.email}</td>
          <td dir="ltr">
            {helperNumber.toPersianNum(mobileHelper.formatMobile(user.mobile))}
          </td>
          <td className="letter-spacing-finance-number">
            {helperNumber.toPersianNum(
              helperNumber.toFormatFinanceNumber(user.wallet)
            )}
          </td>
          <td>{user.registered_at}</td>
          <td>{user.last_login_in}</td>
          <td>
            <div className="text-nowrap">
              <span className="pl-2">
                <Link
                  to={`/user/customer-coworker-info/${user.id}`}
                  className="btn btn-info"
                >
                  <i className="fa fa-info"></i>
                </Link>
              </span>

              <span className="pl-2">
                <Link
                  href="# "
                  className="btn btn-warning"
                  to={`/report/coworker/campaign/${user.id} `}
                >
                  <i class="fa fa-chart-line"></i>
                </Link>
              </span>

              <ButtonDisable
                buttonTagHtml={
                  <span className="pl-2">
                    <span
                      className="btn btn-success opacity-50"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <i className="fa fa-sign-in-alt"></i>
                    </span>
                  </span>
                }
              />
            </div>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <Sidebar activeItem="users" />

      <div className="content-wrapper">
        <TitleBar title="کاربران مشتریان همکار" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">{generateTable()}</div>
          </div>
        </section>
      </div>
    </>
  );
}
